import { render, staticRenderFns } from "./AddExpensePage.vue?vue&type=template&id=47aeadc1"
import script from "./AddExpensePage.vue?vue&type=script&lang=js"
export * from "./AddExpensePage.vue?vue&type=script&lang=js"
import style0 from "./AddExpensePage.vue?vue&type=style&index=0&id=47aeadc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports